import { useTranslation } from "react-i18next";
import { SettingRow, TextInput, NumberInput, Section } from "./SettingsControls";
import type { DatevFields } from "./useSettings";

interface DatevSettingsProps {
    datev: DatevFields;
    saved: boolean;
    dirty?: boolean;
    onChange: (v: DatevFields) => void;
    onSave: () => void;
}

export function DatevSettings({ datev, onChange }: DatevSettingsProps) {
    const { t } = useTranslation();
    const set = <K extends keyof DatevFields>(key: K, value: DatevFields[K]) =>
        onChange({ ...datev, [key]: value });

    return (
        <Section title={t("settings.datevTitle")} description={t("settings.datevDesc")}>
            <SettingRow title={t("settings.datevBeraterNr")} description={t("settings.datevBeraterNrDesc")}>
                <TextInput label={t("settings.datevBeraterNr")} value={datev.beraterNr} onChange={(v) => set("beraterNr", v)} placeholder="1001" />
            </SettingRow>
            <SettingRow title={t("settings.datevMandantNr")} description={t("settings.datevMandantNrDesc")}>
                <TextInput label={t("settings.datevMandantNr")} value={datev.mandantNr} onChange={(v) => set("mandantNr", v)} placeholder="456" />
            </SettingRow>
            <SettingRow title={t("settings.datevRevenueAccount")} description={t("settings.datevRevenueAccountDesc")}>
                <TextInput label={t("settings.datevRevenueAccount")} value={datev.revenueAccount} onChange={(v) => set("revenueAccount", v)} placeholder="8400" />
            </SettingRow>
            <SettingRow title={t("settings.datevDebtorAccount")} description={t("settings.datevDebtorAccountDesc")}>
                <TextInput label={t("settings.datevDebtorAccount")} value={datev.debtorAccount} onChange={(v) => set("debtorAccount", v)} placeholder="10000" />
            </SettingRow>
            <SettingRow title={t("settings.datevAccountLength")} description={t("settings.datevAccountLengthDesc")}>
                <NumberInput value={datev.accountLength} onChange={(v) => set("accountLength", v)} min={4} max={8} label={t("settings.datevAccountLength")} />
            </SettingRow>
        </Section>
    );
}
